import React from "react";
import {Route} from "react-router-dom";
import {registryProjectRoutes} from "./registry-project-routes";
import {
  RegistryDefaultSubProjectRedirect,
  RegistrySubProjectRoute,
  RegistryNotFoundRedirect,
  RegistryPageRoute,
  RegistryProjectRoute
} from "./RegistryProjectRoute";

// Pages with a sub-route: the designer opens one flow of the sub project at flow/:flowId
const designerRoute = registryProjectRoutes.find(route => route.path === "flow");

// Route tree for registry projects, placed inside <Routes> in App.js:
// /registry-project/:registryProjectId                 loads the project (RegistryProjectRoute)
//   index                                              redirects to the first sub project
//   :subProjectId                                      layout with the selected sub project (RegistrySubProjectRoute)
//     "" / supervision / flow / ...                    menu pages (RegistryPageRoute)
export const registryProjectRouteElement = (
  <Route path="/registry-project/:registryProjectId" element={<RegistryProjectRoute/>}>
    <Route index element={<RegistryDefaultSubProjectRedirect/>}/>
    <Route path=":subProjectId" element={<RegistrySubProjectRoute/>}>
      {registryProjectRoutes.map(({label, path, roles}) => {
        const element = <RegistryPageRoute label={label} path={path} roles={roles}/>;
        return path
          ? <Route key={path} path={path} element={element}/>
          : <Route key={"index"} index element={element}/>;
      })}
      {designerRoute && (
        <Route
          path={"flow/:flowId"}
          element={<RegistryPageRoute label={designerRoute.label} path={"flow"} roles={designerRoute.roles}/>}
        />
      )}
      <Route path={"*"} element={<RegistryNotFoundRedirect/>}/>
    </Route>
  </Route>
);
